import { ErrorHandler, Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { environment } from '@env/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import packageInfo from '../../../../package.json';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private restSerivce: RestService, private deviceDetectorService: DeviceDetectorService) {}

  public async handleError(error: Error): Promise<void> {

    console.error('Fehler aufgetreten: ', error);
    console.error('Fehler aufgetreten: ', error.stack);
    console.error('Fehler aufgetreten: ', error.message);
    if (environment.name !== 'local') {
      await this.restSerivce
        .sendClientError({
          url:           window.location.href,
          stacktrace:    `${error.message}\n\n${error.stack}`,
          deviceInfo:    this.getDeviceDescription(),
          clientVersion: packageInfo.version
        })
        .toPromise();
    }
  }

  private getDeviceDescription(): string {
    return `browser:    ${this.deviceDetectorService.browser + ' / ' + this.deviceDetectorService.browser_version}\n` +
      'localtime: ' + new Date().toLocaleString() + '\n' +
      `os: ${this.deviceDetectorService.os + ' ' + this.deviceDetectorService.os_version}\n` +
      `device Type: ${this.getDeviceType()}\n` +
      `resolution: ${window && window.innerWidth ? window.innerWidth : '?'} x ${window && window.innerHeight ? window.innerHeight : '?'}`;
  }

  private getDeviceType(): string {
    let str = 'unknown';
    if (this.deviceDetectorService.isDesktop()) {
      str = 'desktop';
    }
    if (this.deviceDetectorService.isMobile()) {
      str = 'handset';
    }
    if (this.deviceDetectorService.isTablet()) {
      str = 'tablet';
    }
    return str;
  }

}
